module.exports = __webpack_public_path__ + "img/medal_3.71e185eb.png";